import { apiClientGeral } from '@/plugins/axios'

export default {
  getCentroDeCustos() {
    return apiClientGeral().get('/centrodecusto')
  },
  getCentroDeCusto(id) {
    return apiClientGeral().get(`/centrodecusto/${id}`)
  },
  postCentroDeCustos(centroDeCusto) {
    return apiClientGeral().post('/centrodecusto', centroDeCusto)
  },
  putCentroDeCustos(centroDeCusto) {
    return apiClientGeral().put(`/centrodecusto/${centroDeCusto._id}`, centroDeCusto)
  },
  deleteCentroDeCustos(id) {
    return apiClientGeral().delete(`/centrodecusto/${id}`)
  },
}
